import { Component, OnInit } from '@angular/core';
import { Artiste } from '../../models/artiste.model';
import { ArtisteService } from '../../services/artiste.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-artistes',
  templateUrl: './gestion-artistes.component.html',
  styleUrls: ['../gestion-evenements/gestion-evenements.component.css']
})
export class GestionArtistesComponent implements OnInit {

  artistes: Artiste[] = [];
  formArtiste: Artiste = this.formVide();
  idEnModification: number | null = null;
  messageConfirmation = '';
  texteRecherche = '';

  constructor(
    private artisteService: ArtisteService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.chargerArtistes();
  }

  chargerArtistes(): void {
    this.artisteService.getArtistes().subscribe(data => {
      this.artistes = data;
    });
  }

  get artistesFiltres(): Artiste[] {
    return this.artistes.filter(a =>
      a.nom.toLowerCase().includes(this.texteRecherche.toLowerCase())
    );
  }

  formVide(): Artiste {
    return { nom: '', role: '', bio: '', photoUrl: '' };
  }

  validerFormulaire(): void {
    if (this.idEnModification !== null) {
      this.artisteService.updateArtiste(this.idEnModification, this.formArtiste).subscribe(() => {
        this.messageConfirmation = 'Artiste modifié avec succès !';
        this.journalService.ajouter(`Artiste « ${this.formArtiste.nom} » modifié.`).subscribe();
        this.annulerModification();
        this.chargerArtistes();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    } else {
      this.artisteService.createArtiste(this.formArtiste).subscribe(() => {
        this.messageConfirmation = 'Artiste ajouté avec succès !';
        this.journalService.ajouter(`Artiste « ${this.formArtiste.nom} » ajouté.`).subscribe();
        this.formArtiste = this.formVide();
        this.chargerArtistes();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    }
  }

  modifierArtiste(artiste: Artiste): void {
    this.idEnModification = artiste.id !== undefined ? artiste.id : null;
    this.formArtiste = { ...artiste };
  }

  annulerModification(): void {
    this.idEnModification = null;
    this.formArtiste = this.formVide();
  }

  supprimerArtiste(artiste: Artiste): void {
    if (artiste.id === undefined) return;

    if (confirm('Supprimer cet artiste ?')) {
      this.artisteService.deleteArtiste(artiste.id).subscribe(() => {
        this.journalService.ajouter(`Artiste « ${artiste.nom} » supprimé.`).subscribe();
        this.chargerArtistes();
      });
    }
  }
}
